<template>
  <a-card style="height: 634px;position: relative;" :bordered="false">
    <a-steps :current="current">
      <a-step v-for="item in steps" :key="item.title" :title="item.title"/>
    </a-steps>
    <div style="margin-top: 50px" v-if="current===0">
      <a-form-model
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="迁移数据内容">
          <a-select v-model="isUser" style="width: 450px" placeholder="请选择">
            <a-select-option :value="1">自我游 / 分销数据</a-select-option>
            <a-select-option :value="2">自我游 / 用户数据</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" :disabled="queryBy" @click="next">下一步</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div v-if="current===1" class="bi-box">
      <div style="font-size: 16px;margin-bottom: 10px">请上传{{ isUser === 2 ? '用户' : '分销员' }}数据</div>
      <a-upload-dragger
        name="file"
        :multiple="false"
        :action="uploadUrl"
        :showUploadList="false"
        :data="uploadData"
        @change="fileInfo=>handleChange(fileInfo,1)"
        :before-upload="handleBeforeUploadExcelFile"
      >
        <p class="ant-upload-drag-icon">
          <a-icon :type="uploading?'loading':'inbox'"/>
        </p>
        <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
        <p class="ant-upload-hint">支持扩展名：.xls .xlsx</p>
      </a-upload-dragger>
      <div style="margin: 50px 0 20px;">共识别到{{ readTotal }}条数据，其中{{ activeTotal }}符合条件</div>
      <a-button type="primary" @click="beganMove">开始搬移</a-button>
      <a-button v-if="isUser===2" style="margin-left: 20px" @click="next">群发提醒</a-button>
      <a-button style="margin-left: 20px" @click="last">返回</a-button>
    </div>
    <div v-if="current===2">
      <a-result>
        <template #icon>
          <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a"/>
        </template>
        <template #extra v-if="isUser===1">
          <a-button type="primary" size="large" @click="onContinue">继续迁移用户数据</a-button>
          <a-button style="margin-left: 20px" @click="last">返回</a-button>
        </template>
        <template #extra v-else>
          <div style="width: 57%;margin: 0 auto;text-align:left">
            请前往公众号-模板消息-从模板库中添加，搜索“重新绑定提醒”，添加编号为：OPENTM206433506的消息模板，并将已添加的模板ID填写在下方。
          </div>
        </template>
      </a-result>
      <a-form-model
        v-if="isUser===2"
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="请输入模板ID">
          <a-input style="width:450px" v-model="templateId" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="massSms">群发用户绑定手机号提醒</a-button>
          <a-button style="margin-left: 20px" @click="last">返回</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="bottom-box" v-if="current<2">
      <div v-if="current===0">
        <div class="title">数据迁移说明</div>
        <div class="explain">
          从原系统导出表格(无需任何修改)后上传即可，支持多次导入，但已存在的数据不支持覆盖，数据迁移不保证100%完成，或存在部分数据无法导入的情况，请知晓。
        </div>
      </div>
      <div v-if="current===1">
        <div v-if="isUser===1">
          <div class="title">自我游分销数据导出方式</div>
          <div class="explain">自我游系统后台：合作伙伴-分销商管理-导出到Excel</div>
        </div>
        <div v-else>
          <div class="title">自我游用户数据导出方式</div>
          <div class="explain">请联系您的商务经理协助提供用户数据表格</div>
        </div>
      </div>
    </div>
    <a-modal
      :closable="false"
      :maskClosable="false"
      :footer="null"
      title="搬移结果"
      :visible="visible"
      @afterClose="afterClose"
    >
      <div style="text-align: center;">搬移成功{{ successCount }}条数据，搬移失败{{ failureCount }}条数据</div>
      <a-button style="margin-left: 75%;margin-top: 20px;" type="primary" @click="onKnow">我知道了</a-button>
    </a-modal>
    <a-modal
      :footer="null"
      :width="600"
      title="上传详情"
      :visible="falseVisible"
      @afterClose="afterFalseClose"
      @cancel="falseVisible=false"
    >
      <div style="max-height: 600px;overflow: auto;line-height: 22px;" v-html="errorMsg"></div>
      <a-button style="margin-left: 75%;margin-top: 20px;" type="primary" @click="falseVisible=false">我知道了
      </a-button>
    </a-modal>
  </a-card>
</template>

<script>
import formMixin from '../../../../utils/mixins/formMixins'

export default {
  name: 'SystemMovingAssistant',
  mixins: [formMixin],
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      steps: [
        {
          title: '选择平台及迁移内容',
          content: 'First-content'
        },
        {
          title: '上传数据表',
          content: 'Second-content'
        },
        {
          title: '完成',
          content: 'Last-content'
        }
      ],
      current: 0,
      currentFormLayout: {
        labelCol: {
          xxl: { span: 8 },
          xl: { span: 8 },
          lg: { span: 8 },
          sm: { span: 8 },
          md: { span: 10 },
          xs: { span: 15 }
        },
        wrapperCol: {
          xxl: { span: 12 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 12 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 12 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 12 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 7 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 5 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 8 },
          xl: { offset: 8 },
          lg: { offset: 8 },
          sm: { offset: 8 },
          md: { offset: 10 },
          xs: { offset: 15 }
        }
      },
      uploadUrl: '',
      uploadData: {},
      imageUrl: '',
      isUser: 1,
      queryBy: true,// 是否通过授权
      readTotal: 0,//读取总数
      activeTotal: 0,//可用总数
      cacheFlag: '',
      templateId: '',
      visible: false,
      failureCount: 0,//搬移失败条数
      successCount: 0,//搬移成功条数
      errorMsg: '',
      falseVisible: false,
      uploading: false
    }
  },
  watch: {
    'isUser': function(newVal, oldVal) {
      console.error('isUser', this.isUser)
      this.cacheFlag = ''
      this.readTotal = 0
      this.activeTotal = 0
      this.resetData()
      if (newVal === 1) {
        this.uploadUrl = this.getAppConfig().userUrl + '/v2/transfer/staff/readExcel'
      } else {
        this.uploadUrl = this.getAppConfig().userUrl + '/v2/transfer/member/readExcel'
      }
    }
  },
  mounted() {
    this.uploadData = {
      token: this.$store.getters.token
    }
    this.uploadUrl = this.getAppConfig().userUrl + '/v2/transfer/staff/readExcel'
    this.checkOfficialAccounts()
  },
  methods: {
    resetData() {
      this.readTotal = 0
      this.activeTotal = 0
      this.cacheFlag = ''
      this.templateId = ''
      this.errorMsg = ''
      this.failureCount = 0
      this.successCount = 0
    },
    afterFalseClose() {
      this.errorMsg = ''
    },
    afterClose() {
      this.failureCount = 0
      this.successCount = 0
    },
    checkOfficialAccounts() {
      this.getHttpServices().getUserService().post('v2/transfer/member/officaccountValid')
        .then(res => {
          this.queryBy = false
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onContinue() {
      this.current = 1
      this.isUser = 2
    },
    beganMove() {
      if (this.cacheFlag) {
        if (this.isUser === 1) {
          this.staffExecuteTransfer()
        } else {
          this.userExecuteTransfer()
        }
      } else {
        let msg = this.isUser === 1 ? '请上传分销员数据' : '请上传用户数据'
        this.$message.error(msg)
      }
    },
    userExecuteTransfer() {
      let params = {
        cacheFlag: this.cacheFlag
      }
      this.getHttpServices().getUserService().post('v2/transfer/member/executeTransfer', params)
        .then(res => {
          this.failureCount = res.failureCount
          this.successCount = res.successCount
          this.visible = true
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    staffExecuteTransfer() {
      let params = {
        cacheFlag: this.cacheFlag
      }
      this.getHttpServices().getUserService().post('v2/transfer/staff/executeTransfer', params)
        .then(res => {
          if (res.failureCount && res.successCount) {
            this.failureCount = res.failureCount
            this.successCount = res.successCount
            this.visible = true
          }
          if (res) {
            this.$message.success(res)
          }
          this.next()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    massSms() {
      if (this.templateId) {
        let params = {
          templateId: this.templateId
        }
        this.getHttpServices().getUserService().post('v2/transfer/member/sendTemplateByBindMember', params)
          .then(res => {
            this.$message.success('发送成功')
            if (res) {
              this.$message.success(res)
            }
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.$message.error('请输入模板ID')
      }
    },
    onKnow() {
      this.visible = false
    },
    last() {
      this.current--
      this.resetData()
    },
    next() {
      this.current++
    },
    //Excel文件校验
    handleBeforeUploadExcelFile(file) {
      let extensionsName = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = extensionsName === 'xls'
      const extension2 = extensionsName === 'xlsx'
      if (!(extension || extension2)) {
        this.$message.error('上传文件只能是xls、xlsx格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于1M!')
        return false
      }
      return true
    },
    handleChange(fileInfo, index) {
      if (fileInfo.file.status === 'uploading') {
      } else if (fileInfo.file.status === 'done') {
        if (fileInfo.file.response.status === 1) {
          this.$message.success('上传成功')
          this.uploading = false
          let data = fileInfo.file.response.data
          if (data) {
            this.readTotal = data.readTotal
            this.activeTotal = data.activeTotal
            this.cacheFlag = data.cacheFlag
          }
          this.errorMsg = data.errorMsg.replace(/\n/g, '<br>')
          if (this.errorMsg) {
            this.falseVisible = true
          }
        } else {
          this.$message.error('上传失败，请重试')
        }
      }
    }
  }
}
</script>

<style lang="less">
.bottom-box {
  border-top: 1px solid #ebebeb;
  width: 96%;
  height: 70px;
  position: absolute;
  bottom: 70px;
  color: #00000072;

  .title {
    margin-top: 30px;
    font-width: bold;
  }

  .explain {
    margin-top: 10px;
  }
}

.bi-box {
  margin: 50px auto 0;
  width: 438px;
  height: 192px;

  .ant-upload.ant-upload-drag {
    border: 2px dashed #FAAD14;
  }
}
</style>